export enum TemplateType {
  Custom = "Custom",
  One = "One",
  Two = "Two",
  Three = "Three",
  Four = "Four",
  Five = "Five",
  Six = "Six",
  Seven = "Seven",
  Eight = "Eight",
  Nine = "Nine",
  Eleven = "Eleven",
  Twelve = "Twelve",
  PictureInPicture = "PictureInPicture",
}
